import styled from 'styled-components';

export const StyledDiv = styled.div`
  display: flex;
  flex-wrap: nowrap;
  max-width: 10000vh;
  height: 100vh;
  /* overflow: hidden; */
`;
